/**
 * Enable search suggestions in the brand page search bar. * PRD: https:www.notion.so/faire/Improved-brand-page-search-suggestions-f7881e256ffc40ef803628d2bfc9bab2?pvs=4
 */
export const BRAND_PRODUCT_SEARCH_SUGGESTIONS_ENABLED_240516 = 'BRAND_PRODUCT_SEARCH_SUGGESTIONS_ENABLED_240516';
